<template>
<v-container fluid>
		<div v-if="!loading">
			<div id="print-retail-pdf">
				<!--table 1 design-->
				<v-row class="total secondary--text mb-4">Independent retailers</v-row>
				<!--table head-->
				<v-row class="total mt-4" no-gutters>
					<v-col cols="1" class="tabCell text-left">Chain</v-col>
					<v-col cols="11" class="tabCell">
						<v-row no-gutters>
							<v-col cols="3" class="tabCell text-center">Channel performance</v-col>
							<v-col cols="1" class="tabCell text-center">Sales</v-col>
							
							<v-col cols="3" class="tabCell text-center">Business conditions</v-col>
							<v-col cols="5" class="tabCell text-center">Business profile</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col v-for="item in headers"
								:key="item">
								{{item}}
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<!--table content-->
				<v-row class="caption secondary--text my-2">
					<strong>Online</strong>
				</v-row>
				<v-row v-for="channel in marketplaces" :key="channel.id" no-gutters>
					<v-col class="tabCell text-left caption font-weight-bold">{{channel.name}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{channel.numbers}}</v-col>
					<v-col class="tabCell">{{format(channel.coverage)}}</v-col>
					<v-col class="tabCell">{{format(chainCoverage(channel))}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{format(channel.previousSales)}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{format(channel.entryFee)}}</v-col>
					<v-col class="tabCell">{{format(channel.flatFee)}}</v-col>
					<v-col class="tabCell">{{procentFormat(channel.margin)}}</v-col>
					<v-col class="tabCell">{{channel.trademarkNum}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{channel.minPrice}}</v-col>
					<v-col class="tabCell">{{channel.maxPrice}}</v-col>
					<v-col class="tabCell">{{channel.mainDesign}}</v-col>
					<v-col class="tabCell">{{channel.secondDesign}}</v-col>
				</v-row>
				<v-row class="caption secondary--text my-2">
					<strong>Brick & mortar</strong>
				</v-row>
				<v-row 
					v-for="channel in chains"
					:key="channel.id" 
					no-gutters>
					<v-col class="tabCell text-left caption font-weight-bold">{{channel.name}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{channel.numbers}}</v-col>
					<v-col class="tabCell">{{format(channel.coverage)}}</v-col>
					<v-col class="tabCell">{{format(chainCoverage(channel))}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{format(channel.previousSales)}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{format(channel.entryFee)}}</v-col>
					<v-col class="tabCell">{{format(channel.flatFee)}}</v-col>
					<v-col class="tabCell">{{procentFormat(channel.margin)}}</v-col>
					<v-col class="tabCell">{{channel.trademarkNum}}</v-col>
					<v-divider vertical class="mx-1"></v-divider>
					<v-col class="tabCell">{{channel.minPrice}}</v-col>
					<v-col class="tabCell">{{channel.maxPrice}}</v-col>
					<v-col class="tabCell">{{channel.mainDesign}}</v-col>
					<v-col class="tabCell">{{channel.secondDesign}}</v-col>
				</v-row>
				
			</div>
			<v-row class="ma-4" justify="end">
				<v-btn
					color="#1A237E" small dark
					class="text-lowercase"
					@click="generateReport"
					>save in PDF
				</v-btn>
			</v-row>	
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import numeral from 'numeral'
	import html2pdf from 'html2pdf.js'
	import Loader from '../../../layouts/Loader.vue'

	export default {
		props: ['company', 'gameId', 'round'],
		data (){
			return {
				headers: ['Store count', 'Peak market coverage (1 store)', 'Peak market coverage (total)', 'Sales last year (units)', 'Entry fee', 'Annual flat fee', 'Target retail margin', 'Number trademarks', 'Min price', 'Max price', 'Main design type', 'Second design type']

			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			marketplaces () {
				return this.$store.getters.marketplaces
			},
			chains () {
				return this.$store.getters.chains
			},
			projects () {
				return this.$store.getters.projects
			},
			marketConsultancy () {
				return Boolean(this.projects.find(project => project.name == 'Marketing & Retail'))
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('0,0[.]0')//
			},
			procentFormat (param) {
				return numeral(param).format('% 0[.]0')
			},
			chainCoverage (channel) {
				return (channel.coverage * channel.numbers)
			},
			generateReport () {
				let element = document.getElementById('print-retail-pdf');
				var opt = {
					margin: 1,
					filename: 'retailReport.pdf',
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas:  { scale: 2 },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
					pagebreak: { mode: 'avoid-all', before: '.nextPage' }
				};
				// New Promise-based usage:
				html2pdf().set(opt).from(element).save();
			}
		},
		components: {Loader}
	}	
</script>